import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import BusinessApi from "../../services/BusinessApiService";

export default function BusinessResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr(null);
    setMsg(null);

    if (!token) return setErr("Invalid or missing reset token.");
    if (password.length < 8) return setErr("Password must be at least 8 characters.");
    if (password !== confirm) return setErr("Passwords do not match.");

    try {
      setLoading(true);
      const res = await BusinessApi.resetPassword(token, password);
      if (res?.success) {
        setMsg("Password reset! Redirecting to login…");
        setTimeout(() => navigate("/business/login"), 1200);
      } else {
        setErr(res?.message || "Reset failed. Try requesting a new link.");
      }
    } catch (e: any) {
      setErr(e?.message || "Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-gray-50">
      <form onSubmit={onSubmit} className="bg-white p-6 rounded-2xl shadow w-full max-w-sm">
        <h1 className="text-xl font-semibold mb-4">Set a new password</h1>

        {err && (
          <div className="mb-3 text-sm text-red-700 bg-red-50 border border-red-200 p-2 rounded">
            {err}
          </div>
        )}
        {msg && (
          <div className="mb-3 text-sm text-green-700 bg-green-50 border border-green-200 p-2 rounded">
            {msg}
          </div>
        )}

        <label className="block text-sm mb-1">New password</label>
        <input
          className="w-full border rounded px-3 py-2 mb-3"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <label className="block text-sm mb-1">Confirm password</label>
        <input
          className="w-full border rounded px-3 py-2 mb-4"
          type="password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          required
        />

        <button
          className="w-full bg-blue-600 text-white rounded py-2 disabled:opacity-50"
          disabled={loading}
        >
          {loading ? "Saving…" : "Reset Password"}
        </button>

        <div className="mt-3 text-center">
          <Link to="/business/login" className="text-sm text-blue-600">
            Back to login
          </Link>
        </div>
      </form>
    </div>
  );
}
